//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { AuthClient } from '../app/services/authService';
import { getAccessToken } from 'app/utils/authUtilities';
export class ArticleApiClientBase {
    constructor() { };

    protected async transformOptions(options: RequestInit): Promise<RequestInit> {
        if (options.headers) {
            let token = getAccessToken();
            if(token === null) {
                token = await new AuthClient().getToken();
            }
            var headers = options.headers as { [index: string]: string };
            headers['Authorization'] = `Bearer ${token}`;
        }
        return Promise.resolve(options);
    }

    protected async transformResult(
        url: string,
        response: Response,
        processResponse: (_response: Response) => Promise<any>
    ): Promise<any> {
        try {
            return await processResponse(response);
        } catch (error: any) {
            if(response.ok) {
                return;
            }

            throw new ApiError(
                response.status,
                response.statusText,
                error?.result ?? error
            );
        }
    }
}

export class ArticleApiClient extends ArticleApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Create an Article Category
     * @return Returns the newly created article category id
     */
    articleCategory_CreateArticleCategory(articleCategory: CreateArticleCategoryDto): Promise<GetArticleCategoryDto> {
        let url_ = this.baseUrl + "/Article/ArticleCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(articleCategory);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processArticleCategory_CreateArticleCategory(_response));
        });
    }

    protected processArticleCategory_CreateArticleCategory(response: Response): Promise<GetArticleCategoryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetArticleCategoryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("There are any validation errors", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetArticleCategoryDto>(null as any);
    }

    /**
     * Update an article category
     * @return Returns the updated article category object
     */
    articleCategory_UpdateArticleCategory(articleCategory: UpdateArticleCategoryDto): Promise<GetArticleCategoryDto> {
        let url_ = this.baseUrl + "/Article/ArticleCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(articleCategory);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processArticleCategory_UpdateArticleCategory(_response));
        });
    }

    protected processArticleCategory_UpdateArticleCategory(response: Response): Promise<GetArticleCategoryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetArticleCategoryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("There are any validation errors", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("When the ArticleCategoryID is not found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetArticleCategoryDto>(null as any);
    }

    /**
     * Get the Article Category
     * @param id The Guid
     * @return Returns the article category object
     */
    articleCategory_GetArticleCategoryById(id: string): Promise<GetArticleCategoryDto> {
        let url_ = this.baseUrl + "/Article/ArticleCategory/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processArticleCategory_GetArticleCategoryById(_response));
        });
    }

    protected processArticleCategory_GetArticleCategoryById(response: Response): Promise<GetArticleCategoryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetArticleCategoryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("When the ArticleCategoryID is not found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetArticleCategoryDto>(null as any);
    }

    /**
     * Delete an article category
     * @param id The Guid
     * @return If the Deletion was success or failure
     */
    articleCategory_DeleteArticleCategory(id: string): Promise<void> {
        let url_ = this.baseUrl + "/Article/ArticleCategory/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processArticleCategory_DeleteArticleCategory(_response));
        });
    }

    protected processArticleCategory_DeleteArticleCategory(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get article categories
     * @return List of Article Categories
     */
    articleCategory_GetArticleCategories(): Promise<GetArticleCategoryDto[]> {
        let url_ = this.baseUrl + "/Article/ArticleCategory/List";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processArticleCategory_GetArticleCategories(_response));
        });
    }

    protected processArticleCategory_GetArticleCategories(response: Response): Promise<GetArticleCategoryDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetArticleCategoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetArticleCategoryDto[]>(null as any);
    }

    /**
     * Create an Article
     * @return Returns the newly created article
     */
    article_CreateArticle(article: CreateArticleDto): Promise<GetArticleDetailDto> {
        let url_ = this.baseUrl + "/Article";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(article);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processArticle_CreateArticle(_response));
        });
    }

    protected processArticle_CreateArticle(response: Response): Promise<GetArticleDetailDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetArticleDetailDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("There are any validation errors", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetArticleDetailDto>(null as any);
    }

    /**
     * Update an article
     * @return Returns the updated article object
     */
    article_UpdateArticle(article: UpdateArticleDto): Promise<GetArticleDetailDto> {
        let url_ = this.baseUrl + "/Article";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(article);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processArticle_UpdateArticle(_response));
        });
    }

    protected processArticle_UpdateArticle(response: Response): Promise<GetArticleDetailDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetArticleDetailDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("There are any validation errors", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("When the ArticleID is not found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetArticleDetailDto>(null as any);
    }

    /**
     * Get the Article
     * @param id The Guid
     * @return Returns the article object
     */
    article_GetArticleById(id: string): Promise<GetArticleDetailDto> {
        let url_ = this.baseUrl + "/Article/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processArticle_GetArticleById(_response));
        });
    }

    protected processArticle_GetArticleById(response: Response): Promise<GetArticleDetailDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetArticleDetailDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("When the ArticleID is not found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetArticleDetailDto>(null as any);
    }

    /**
     * Delete an article
     * @param id The Guid
     * @return If the Deletion was success or failure
     */
    article_DeleteArticle(id: string): Promise<void> {
        let url_ = this.baseUrl + "/Article/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processArticle_DeleteArticle(_response));
        });
    }

    protected processArticle_DeleteArticle(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    article_GetRelatedArticlesById(id: string): Promise<PaginatedListOfGetArticleSummaryDto> {
        let url_ = this.baseUrl + "/Article/{id}/Related";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processArticle_GetRelatedArticlesById(_response));
        });
    }

    protected processArticle_GetRelatedArticlesById(response: Response): Promise<PaginatedListOfGetArticleSummaryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfGetArticleSummaryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfGetArticleSummaryDto>(null as any);
    }

    /**
     * Get articles with pagination
     * @param articleIdForRelatedArticles (optional) 
     * @param articleTagsForRelatedArticles (optional) 
     * @param status (optional) 
     * @param type (optional) 
     * @param filterHomePageArticles (optional) 
     * @param filterBannerArticle (optional) 
     * @param authorId (optional) 
     * @param tag (optional) 
     * @param rootTag (optional) 
     * @param tagId (optional) 
     * @param scheduledPublishDueTime (optional) 
     * @param sortProperty (optional) 
     * @param sortDirection (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @return List of Article for specified Page Number and Page Size
     */
    article_GetArticles(articleIdForRelatedArticles: string | null | undefined, articleTagsForRelatedArticles: string[] | null | undefined, status: ArticleStatus | null | undefined, type: ArticleType | null | undefined, filterHomePageArticles: boolean | undefined, filterBannerArticle: boolean | undefined, authorId: string | null | undefined, tag: string | null | undefined, rootTag: string | null | undefined, tagId: string | null | undefined, scheduledPublishDueTime: Date | null | undefined, sortProperty: string | null | undefined, sortDirection: ListSortDirection | undefined, pageNumber: number | undefined, pageSize: number | undefined): Promise<PaginatedListOfGetArticleSummaryDto> {
        let url_ = this.baseUrl + "/Article/List?";
        if (articleIdForRelatedArticles !== undefined && articleIdForRelatedArticles !== null)
            url_ += "ArticleIdForRelatedArticles=" + encodeURIComponent("" + articleIdForRelatedArticles) + "&";
        if (articleTagsForRelatedArticles !== undefined && articleTagsForRelatedArticles !== null)
            articleTagsForRelatedArticles && articleTagsForRelatedArticles.forEach(item => { url_ += "ArticleTagsForRelatedArticles=" + encodeURIComponent("" + item) + "&"; });
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (type !== undefined && type !== null)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (filterHomePageArticles === null)
            throw new Error("The parameter 'filterHomePageArticles' cannot be null.");
        else if (filterHomePageArticles !== undefined)
            url_ += "FilterHomePageArticles=" + encodeURIComponent("" + filterHomePageArticles) + "&";
        if (filterBannerArticle === null)
            throw new Error("The parameter 'filterBannerArticle' cannot be null.");
        else if (filterBannerArticle !== undefined)
            url_ += "FilterBannerArticle=" + encodeURIComponent("" + filterBannerArticle) + "&";
        if (authorId !== undefined && authorId !== null)
            url_ += "AuthorId=" + encodeURIComponent("" + authorId) + "&";
        if (tag !== undefined && tag !== null)
            url_ += "Tag=" + encodeURIComponent("" + tag) + "&";
        if (rootTag !== undefined && rootTag !== null)
            url_ += "RootTag=" + encodeURIComponent("" + rootTag) + "&";
        if (tagId !== undefined && tagId !== null)
            url_ += "TagId=" + encodeURIComponent("" + tagId) + "&";
        if (scheduledPublishDueTime !== undefined && scheduledPublishDueTime !== null)
            url_ += "ScheduledPublishDueTime=" + encodeURIComponent(scheduledPublishDueTime ? "" + scheduledPublishDueTime.toISOString() : "") + "&";
        if (sortProperty !== undefined && sortProperty !== null)
            url_ += "SortProperty=" + encodeURIComponent("" + sortProperty) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processArticle_GetArticles(_response));
        });
    }

    protected processArticle_GetArticles(response: Response): Promise<PaginatedListOfGetArticleSummaryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfGetArticleSummaryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfGetArticleSummaryDto>(null as any);
    }

    /**
     * Get sets of articles for Newsfeed/Knowledge Articles landing page (End-user)
     * @param type (optional) 
     * @return List of News broken into sets according to categories and sorted
     */
    article_GetHomeArticles(type: ArticleType | undefined): Promise<ArticlesHomeDto> {
        let url_ = this.baseUrl + "/Article/Home?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processArticle_GetHomeArticles(_response));
        });
    }

    protected processArticle_GetHomeArticles(response: Response): Promise<ArticlesHomeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArticlesHomeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ArticlesHomeDto>(null as any);
    }

    article_GetArticlesByType(articleIdForRelatedArticles: string | null | undefined, articleTagsForRelatedArticles: string[] | null | undefined, status: ArticleStatus | null | undefined, type: ArticleType | null | undefined, filterHomePageArticles: boolean | undefined, filterBannerArticle: boolean | undefined, authorId: string | null | undefined, tag: string | null | undefined, rootTag: string | null | undefined, tagId: string | null | undefined, scheduledPublishDueTime: Date | null | undefined, sortProperty: string | null | undefined, sortDirection: ListSortDirection | undefined, pageNumber: number | undefined, pageSize: number | undefined): Promise<PaginatedListOfGetArticleSummaryDto> {
        let url_ = this.baseUrl + "/Article/Type?";
        if (articleIdForRelatedArticles !== undefined && articleIdForRelatedArticles !== null)
            url_ += "ArticleIdForRelatedArticles=" + encodeURIComponent("" + articleIdForRelatedArticles) + "&";
        if (articleTagsForRelatedArticles !== undefined && articleTagsForRelatedArticles !== null)
            articleTagsForRelatedArticles && articleTagsForRelatedArticles.forEach(item => { url_ += "ArticleTagsForRelatedArticles=" + encodeURIComponent("" + item) + "&"; });
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (type !== undefined && type !== null)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (filterHomePageArticles === null)
            throw new Error("The parameter 'filterHomePageArticles' cannot be null.");
        else if (filterHomePageArticles !== undefined)
            url_ += "FilterHomePageArticles=" + encodeURIComponent("" + filterHomePageArticles) + "&";
        if (filterBannerArticle === null)
            throw new Error("The parameter 'filterBannerArticle' cannot be null.");
        else if (filterBannerArticle !== undefined)
            url_ += "FilterBannerArticle=" + encodeURIComponent("" + filterBannerArticle) + "&";
        if (authorId !== undefined && authorId !== null)
            url_ += "AuthorId=" + encodeURIComponent("" + authorId) + "&";
        if (tag !== undefined && tag !== null)
            url_ += "Tag=" + encodeURIComponent("" + tag) + "&";
        if (rootTag !== undefined && rootTag !== null)
            url_ += "RootTag=" + encodeURIComponent("" + rootTag) + "&";
        if (tagId !== undefined && tagId !== null)
            url_ += "TagId=" + encodeURIComponent("" + tagId) + "&";
        if (scheduledPublishDueTime !== undefined && scheduledPublishDueTime !== null)
            url_ += "ScheduledPublishDueTime=" + encodeURIComponent(scheduledPublishDueTime ? "" + scheduledPublishDueTime.toISOString() : "") + "&";
        if (sortProperty !== undefined && sortProperty !== null)
            url_ += "SortProperty=" + encodeURIComponent("" + sortProperty) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processArticle_GetArticlesByType(_response));
        });
    }

    protected processArticle_GetArticlesByType(response: Response): Promise<PaginatedListOfGetArticleSummaryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfGetArticleSummaryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfGetArticleSummaryDto>(null as any);
    }

    article_GetUrlMetadata(url: string): Promise<UrlMetadataDto> {
        let url_ = this.baseUrl + "/Article/UrlMetadata";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(url);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processArticle_GetUrlMetadata(_response));
        });
    }

    protected processArticle_GetUrlMetadata(response: Response): Promise<UrlMetadataDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UrlMetadataDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UrlMetadataDto>(null as any);
    }

    article_Submit(id: string): Promise<GetArticleDetailDto> {
        let url_ = this.baseUrl + "/Article/{id}/Submit";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processArticle_Submit(_response));
        });
    }

    protected processArticle_Submit(response: Response): Promise<GetArticleDetailDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetArticleDetailDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetArticleDetailDto>(null as any);
    }

    article_Redraft(id: string, articleDto: RedraftArticleDto): Promise<GetArticleDetailDto> {
        let url_ = this.baseUrl + "/Article/{id}/Redraft";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(articleDto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processArticle_Redraft(_response));
        });
    }

    protected processArticle_Redraft(response: Response): Promise<GetArticleDetailDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetArticleDetailDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetArticleDetailDto>(null as any);
    }

    article_Publish(id: string, articleDto: PublishArticleDto): Promise<GetArticleDetailDto> {
        let url_ = this.baseUrl + "/Article/{id}/Publish";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(articleDto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processArticle_Publish(_response));
        });
    }

    protected processArticle_Publish(response: Response): Promise<GetArticleDetailDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetArticleDetailDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetArticleDetailDto>(null as any);
    }

    article_ScheduleToPublish(id: string, articleDto: ScheduleToPublishArticleDto): Promise<GetArticleDetailDto> {
        let url_ = this.baseUrl + "/Article/{id}/ScheduleToPublish";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(articleDto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processArticle_ScheduleToPublish(_response));
        });
    }

    protected processArticle_ScheduleToPublish(response: Response): Promise<GetArticleDetailDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetArticleDetailDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetArticleDetailDto>(null as any);
    }

    article_Remove(id: string): Promise<GetArticleDetailDto> {
        let url_ = this.baseUrl + "/Article/{id}/Remove";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processArticle_Remove(_response));
        });
    }

    protected processArticle_Remove(response: Response): Promise<GetArticleDetailDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetArticleDetailDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetArticleDetailDto>(null as any);
    }

    article_Draft(id: string): Promise<GetArticleDetailDto> {
        let url_ = this.baseUrl + "/Article/{id}/Draft";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processArticle_Draft(_response));
        });
    }

    protected processArticle_Draft(response: Response): Promise<GetArticleDetailDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetArticleDetailDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetArticleDetailDto>(null as any);
    }

    article_TrackView(id: string): Promise<void> {
        let url_ = this.baseUrl + "/Article/{id}/TrackView";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processArticle_TrackView(_response));
        });
    }

    protected processArticle_TrackView(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Create an Article Template
     * @return Returns the newly created article template id
     */
    articleTemplate_CreateArticleTemplate(articleTemplate: CreateArticleTemplateDto): Promise<GetArticleTemplateDetailDto> {
        let url_ = this.baseUrl + "/Article/ArticleTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(articleTemplate);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processArticleTemplate_CreateArticleTemplate(_response));
        });
    }

    protected processArticleTemplate_CreateArticleTemplate(response: Response): Promise<GetArticleTemplateDetailDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetArticleTemplateDetailDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("There are any validation errors", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetArticleTemplateDetailDto>(null as any);
    }

    /**
     * Get the Article Template
     * @param id The Guid
     * @return Returns the article template object
     */
    articleTemplate_GetArticleTemplateById(id: string): Promise<GetArticleTemplateDetailDto> {
        let url_ = this.baseUrl + "/Article/ArticleTemplate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processArticleTemplate_GetArticleTemplateById(_response));
        });
    }

    protected processArticleTemplate_GetArticleTemplateById(response: Response): Promise<GetArticleTemplateDetailDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetArticleTemplateDetailDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("When the ArticleTemplateID is not found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetArticleTemplateDetailDto>(null as any);
    }

    /**
     * Delete an article template
     * @param id The Guid
     * @return If the Deletion was success or failure
     */
    articleTemplate_DeleteArticleTemplate(id: string): Promise<void> {
        let url_ = this.baseUrl + "/Article/ArticleTemplate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processArticleTemplate_DeleteArticleTemplate(_response));
        });
    }

    protected processArticleTemplate_DeleteArticleTemplate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get article templates
     * @return List of Article Templates
     */
    articleTemplate_GetArticleTemplates(): Promise<GetArticleTemplateSummaryDto[]> {
        let url_ = this.baseUrl + "/Article/ArticleTemplate/List";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processArticleTemplate_GetArticleTemplates(_response));
        });
    }

    protected processArticleTemplate_GetArticleTemplates(response: Response): Promise<GetArticleTemplateSummaryDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetArticleTemplateSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetArticleTemplateSummaryDto[]>(null as any);
    }

    /**
     * Update an Author
     * @return Returns the updated author object
     */
    author_UpdateAuthor(author: UpdateAboutAuthorDto): Promise<GetAuthorDto> {
        let url_ = this.baseUrl + "/Article/Author";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(author);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAuthor_UpdateAuthor(_response));
        });
    }

    protected processAuthor_UpdateAuthor(response: Response): Promise<GetAuthorDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAuthorDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("There are any validation errors", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("When the AuthorId is not found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetAuthorDto>(null as any);
    }

    /**
     * Get the Author
     * @param id The Guid
     * @return Returns the author object
     */
    author_GetAuthorById(id: string): Promise<GetAuthorDto> {
        let url_ = this.baseUrl + "/Article/Author/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAuthor_GetAuthorById(_response));
        });
    }

    protected processAuthor_GetAuthorById(response: Response): Promise<GetAuthorDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAuthorDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("When the AuthorId is not found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetAuthorDto>(null as any);
    }

    /**
     * Get authors
     * @param sortProperty (optional) 
     * @param sortDirection (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @return List of Authors
     */
    author_GetAuthors(sortProperty: string | null | undefined, sortDirection: ListSortDirection | undefined, pageNumber: number | undefined, pageSize: number | undefined): Promise<PaginatedListOfGetAuthorDto> {
        let url_ = this.baseUrl + "/Article/Author/List?";
        if (sortProperty !== undefined && sortProperty !== null)
            url_ += "SortProperty=" + encodeURIComponent("" + sortProperty) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAuthor_GetAuthors(_response));
        });
    }

    protected processAuthor_GetAuthors(response: Response): Promise<PaginatedListOfGetAuthorDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfGetAuthorDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfGetAuthorDto>(null as any);
    }

    file_GenerateFileSasToken(containerName: string, fileName: string): Promise<string> {
        let url_ = this.baseUrl + "/Article/File/GenerateFileSasToken/{containerName}/{fileName}";
        if (containerName === undefined || containerName === null)
            throw new Error("The parameter 'containerName' must be defined.");
        url_ = url_.replace("{containerName}", encodeURIComponent("" + containerName));
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined.");
        url_ = url_.replace("{fileName}", encodeURIComponent("" + fileName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processFile_GenerateFileSasToken(_response));
        });
    }

    protected processFile_GenerateFileSasToken(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    file_GenerateContainerSasToken(containerName: string): Promise<string> {
        let url_ = this.baseUrl + "/Article/File/GenerateContainerSasToken/{containerName}";
        if (containerName === undefined || containerName === null)
            throw new Error("The parameter 'containerName' must be defined.");
        url_ = url_.replace("{containerName}", encodeURIComponent("" + containerName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processFile_GenerateContainerSasToken(_response));
        });
    }

    protected processFile_GenerateContainerSasToken(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    home_Index(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/article";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processHome_Index(_response));
        });
    }

    protected processHome_Index(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class GetArticleCategoryDto implements IGetArticleCategoryDto {
    id?: string;
    displayName?: string | undefined;
    description?: string | undefined;
    icon?: string | undefined;
    bannerImage?: string | undefined;
    parentId?: string | undefined;
    children?: GetArticleCategoryDto[] | undefined;
    categoryHierarchy?: string | undefined;
    isValidTag?: boolean;

    constructor(data?: IGetArticleCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.icon = _data["icon"];
            this.bannerImage = _data["bannerImage"];
            this.parentId = _data["parentId"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(GetArticleCategoryDto.fromJS(item));
            }
            this.categoryHierarchy = _data["categoryHierarchy"];
            this.isValidTag = _data["isValidTag"];
        }
    }

    static fromJS(data: any): GetArticleCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetArticleCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["icon"] = this.icon;
        data["bannerImage"] = this.bannerImage;
        data["parentId"] = this.parentId;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item ? item.toJSON() : <any>undefined);
        }
        data["categoryHierarchy"] = this.categoryHierarchy;
        data["isValidTag"] = this.isValidTag;
        return data;
    }
}

export interface IGetArticleCategoryDto {
    id?: string;
    displayName?: string | undefined;
    description?: string | undefined;
    icon?: string | undefined;
    bannerImage?: string | undefined;
    parentId?: string | undefined;
    children?: GetArticleCategoryDto[] | undefined;
    categoryHierarchy?: string | undefined;
    isValidTag?: boolean;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class CreateArticleCategoryDto implements ICreateArticleCategoryDto {
    displayName?: string | undefined;
    description?: string | undefined;
    icon?: string | undefined;
    bannerImage?: string | undefined;
    parentId?: string | undefined;
    isValidTag?: boolean;

    constructor(data?: ICreateArticleCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.icon = _data["icon"];
            this.bannerImage = _data["bannerImage"];
            this.parentId = _data["parentId"];
            this.isValidTag = _data["isValidTag"];
        }
    }

    static fromJS(data: any): CreateArticleCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateArticleCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["icon"] = this.icon;
        data["bannerImage"] = this.bannerImage;
        data["parentId"] = this.parentId;
        data["isValidTag"] = this.isValidTag;
        return data;
    }
}

export interface ICreateArticleCategoryDto {
    displayName?: string | undefined;
    description?: string | undefined;
    icon?: string | undefined;
    bannerImage?: string | undefined;
    parentId?: string | undefined;
    isValidTag?: boolean;
}

export class UpdateArticleCategoryDto implements IUpdateArticleCategoryDto {
    id?: string;
    displayName?: string | undefined;
    description?: string | undefined;
    icon?: string | undefined;
    bannerImage?: string | undefined;
    parentId?: string | undefined;
    isValidTag?: boolean;

    constructor(data?: IUpdateArticleCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.icon = _data["icon"];
            this.bannerImage = _data["bannerImage"];
            this.parentId = _data["parentId"];
            this.isValidTag = _data["isValidTag"];
        }
    }

    static fromJS(data: any): UpdateArticleCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateArticleCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["icon"] = this.icon;
        data["bannerImage"] = this.bannerImage;
        data["parentId"] = this.parentId;
        data["isValidTag"] = this.isValidTag;
        return data;
    }
}

export interface IUpdateArticleCategoryDto {
    id?: string;
    displayName?: string | undefined;
    description?: string | undefined;
    icon?: string | undefined;
    bannerImage?: string | undefined;
    parentId?: string | undefined;
    isValidTag?: boolean;
}

export class GetArticleDetailDto implements IGetArticleDetailDto {
    id?: string;
    coverPhoto?: string | undefined;
    thumbnail?: string | undefined;
    title?: string | undefined;
    content?: string | undefined;
    shouldHideAuthorInfo?: boolean;
    tags?: ArticleTagDto[] | undefined;
    numberOfViews?: number;
    publishedOn?: Date | undefined;
    scheduledPublishOn?: Date | undefined;
    publishedBy?: UserDto | undefined;
    reviewNotes?: string | undefined;
    helpfulResources?: HelpfulResourceDto[] | undefined;
    status?: ArticleStatus;
    type?: ArticleType;
    showOnHomePage?: boolean;
    showAsBannerArticle?: boolean;
    statusName?: string | undefined;
    createdOn?: Date;
    createdBy?: UserDto | undefined;
    modifiedOn?: Date | undefined;
    modifiedBy?: UserDto | undefined;
    isActive?: boolean;

    constructor(data?: IGetArticleDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.coverPhoto = _data["coverPhoto"];
            this.thumbnail = _data["thumbnail"];
            this.title = _data["title"];
            this.content = _data["content"];
            this.shouldHideAuthorInfo = _data["shouldHideAuthorInfo"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(ArticleTagDto.fromJS(item));
            }
            this.numberOfViews = _data["numberOfViews"];
            this.publishedOn = _data["publishedOn"] ? new Date(_data["publishedOn"].toString()) : <any>undefined;
            this.scheduledPublishOn = _data["scheduledPublishOn"] ? new Date(_data["scheduledPublishOn"].toString()) : <any>undefined;
            this.publishedBy = _data["publishedBy"] ? UserDto.fromJS(_data["publishedBy"]) : <any>undefined;
            this.reviewNotes = _data["reviewNotes"];
            if (Array.isArray(_data["helpfulResources"])) {
                this.helpfulResources = [] as any;
                for (let item of _data["helpfulResources"])
                    this.helpfulResources!.push(HelpfulResourceDto.fromJS(item));
            }
            this.status = _data["status"];
            this.type = _data["type"];
            this.showOnHomePage = _data["showOnHomePage"];
            this.showAsBannerArticle = _data["showAsBannerArticle"];
            this.statusName = _data["statusName"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"] ? UserDto.fromJS(_data["createdBy"]) : <any>undefined;
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"] ? UserDto.fromJS(_data["modifiedBy"]) : <any>undefined;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): GetArticleDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetArticleDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["coverPhoto"] = this.coverPhoto;
        data["thumbnail"] = this.thumbnail;
        data["title"] = this.title;
        data["content"] = this.content;
        data["shouldHideAuthorInfo"] = this.shouldHideAuthorInfo;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : <any>undefined);
        }
        data["numberOfViews"] = this.numberOfViews;
        data["publishedOn"] = this.publishedOn ? this.publishedOn.toISOString() : <any>undefined;
        data["scheduledPublishOn"] = this.scheduledPublishOn ? this.scheduledPublishOn.toISOString() : <any>undefined;
        data["publishedBy"] = this.publishedBy ? this.publishedBy.toJSON() : <any>undefined;
        data["reviewNotes"] = this.reviewNotes;
        if (Array.isArray(this.helpfulResources)) {
            data["helpfulResources"] = [];
            for (let item of this.helpfulResources)
                data["helpfulResources"].push(item ? item.toJSON() : <any>undefined);
        }
        data["status"] = this.status;
        data["type"] = this.type;
        data["showOnHomePage"] = this.showOnHomePage;
        data["showAsBannerArticle"] = this.showAsBannerArticle;
        data["statusName"] = this.statusName;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy ? this.modifiedBy.toJSON() : <any>undefined;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IGetArticleDetailDto {
    id?: string;
    coverPhoto?: string | undefined;
    thumbnail?: string | undefined;
    title?: string | undefined;
    content?: string | undefined;
    shouldHideAuthorInfo?: boolean;
    tags?: ArticleTagDto[] | undefined;
    numberOfViews?: number;
    publishedOn?: Date | undefined;
    scheduledPublishOn?: Date | undefined;
    publishedBy?: UserDto | undefined;
    reviewNotes?: string | undefined;
    helpfulResources?: HelpfulResourceDto[] | undefined;
    status?: ArticleStatus;
    type?: ArticleType;
    showOnHomePage?: boolean;
    showAsBannerArticle?: boolean;
    statusName?: string | undefined;
    createdOn?: Date;
    createdBy?: UserDto | undefined;
    modifiedOn?: Date | undefined;
    modifiedBy?: UserDto | undefined;
    isActive?: boolean;
}

export class ArticleTagDto implements IArticleTagDto {
    id?: string;
    displayName?: string | undefined;
    tagHierarchy?: string | undefined;

    constructor(data?: IArticleTagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.tagHierarchy = _data["tagHierarchy"];
        }
    }

    static fromJS(data: any): ArticleTagDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleTagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["tagHierarchy"] = this.tagHierarchy;
        return data;
    }
}

export interface IArticleTagDto {
    id?: string;
    displayName?: string | undefined;
    tagHierarchy?: string | undefined;
}

export class UserDto implements IUserDto {
    id?: string;
    displayName?: string | undefined;
    email?: string | undefined;
    userDomain?: RequestDomain | undefined;
    userRoles?: UserRole[] | undefined;
    contactNumber?: string | undefined;
    profilePic?: string | undefined;
    businessPhones?: string[] | undefined;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.email = _data["email"];
            this.userDomain = _data["userDomain"];
            if (Array.isArray(_data["userRoles"])) {
                this.userRoles = [] as any;
                for (let item of _data["userRoles"])
                    this.userRoles!.push(UserRole.fromJS(item));
            }
            this.contactNumber = _data["contactNumber"];
            this.profilePic = _data["profilePic"];
            if (Array.isArray(_data["businessPhones"])) {
                this.businessPhones = [] as any;
                for (let item of _data["businessPhones"])
                    this.businessPhones!.push(item);
            }
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["email"] = this.email;
        data["userDomain"] = this.userDomain;
        if (Array.isArray(this.userRoles)) {
            data["userRoles"] = [];
            for (let item of this.userRoles)
                data["userRoles"].push(item ? item.toJSON() : <any>undefined);
        }
        data["contactNumber"] = this.contactNumber;
        data["profilePic"] = this.profilePic;
        if (Array.isArray(this.businessPhones)) {
            data["businessPhones"] = [];
            for (let item of this.businessPhones)
                data["businessPhones"].push(item);
        }
        return data;
    }
}

export interface IUserDto {
    id?: string;
    displayName?: string | undefined;
    email?: string | undefined;
    userDomain?: RequestDomain | undefined;
    userRoles?: UserRole[] | undefined;
    contactNumber?: string | undefined;
    profilePic?: string | undefined;
    businessPhones?: string[] | undefined;
}

export enum RequestDomain {
    SDSG = 1,
    CXP = 2,
    CSS = 3,
    Crew = 4,
    Admin = 5,
}

export class UserRole implements IUserRole {
    roleName?: string | undefined;

    constructor(data?: IUserRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleName = _data["roleName"];
        }
    }

    static fromJS(data: any): UserRole {
        data = typeof data === 'object' ? data : {};
        let result = new UserRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleName"] = this.roleName;
        return data;
    }
}

export interface IUserRole {
    roleName?: string | undefined;
}

export class HelpfulResourceDto implements IHelpfulResourceDto {
    icon?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    customTitle?: string | undefined;
    url?: string | undefined;

    constructor(data?: IHelpfulResourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.icon = _data["icon"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.customTitle = _data["customTitle"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): HelpfulResourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new HelpfulResourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["icon"] = this.icon;
        data["title"] = this.title;
        data["description"] = this.description;
        data["customTitle"] = this.customTitle;
        data["url"] = this.url;
        return data;
    }
}

export interface IHelpfulResourceDto {
    icon?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    customTitle?: string | undefined;
    url?: string | undefined;
}

export enum ArticleStatus {
    Draft = 1,
    Submitted = 2,
    ScheduledToPublish = 3,
    Published = 4,
    Removed = 5,
}

export enum ArticleType {
    KnowledgeArticle = 1,
    NewsArticle = 2,
    TrainingArticle = 3,
    TrainingAdminOnlyArticle = 4,
}

export class CreateArticleDto implements ICreateArticleDto {
    coverPhoto?: string | undefined;
    thumbnail?: string | undefined;
    title?: string | undefined;
    content?: string | undefined;
    type?: ArticleType;
    shouldHideAuthorInfo?: boolean;
    tags?: ArticleTagDto[] | undefined;
    helpfulResources?: HelpfulResourceDto[] | undefined;

    constructor(data?: ICreateArticleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.coverPhoto = _data["coverPhoto"];
            this.thumbnail = _data["thumbnail"];
            this.title = _data["title"];
            this.content = _data["content"];
            this.type = _data["type"];
            this.shouldHideAuthorInfo = _data["shouldHideAuthorInfo"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(ArticleTagDto.fromJS(item));
            }
            if (Array.isArray(_data["helpfulResources"])) {
                this.helpfulResources = [] as any;
                for (let item of _data["helpfulResources"])
                    this.helpfulResources!.push(HelpfulResourceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateArticleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateArticleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coverPhoto"] = this.coverPhoto;
        data["thumbnail"] = this.thumbnail;
        data["title"] = this.title;
        data["content"] = this.content;
        data["type"] = this.type;
        data["shouldHideAuthorInfo"] = this.shouldHideAuthorInfo;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.helpfulResources)) {
            data["helpfulResources"] = [];
            for (let item of this.helpfulResources)
                data["helpfulResources"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface ICreateArticleDto {
    coverPhoto?: string | undefined;
    thumbnail?: string | undefined;
    title?: string | undefined;
    content?: string | undefined;
    type?: ArticleType;
    shouldHideAuthorInfo?: boolean;
    tags?: ArticleTagDto[] | undefined;
    helpfulResources?: HelpfulResourceDto[] | undefined;
}

export class UpdateArticleDto implements IUpdateArticleDto {
    id?: string;
    coverPhoto?: string | undefined;
    thumbnail?: string | undefined;
    title?: string | undefined;
    content?: string | undefined;
    type?: ArticleType;
    shouldHideAuthorInfo?: boolean;
    tags?: ArticleTagDto[] | undefined;
    helpfulResources?: HelpfulResourceDto[] | undefined;

    constructor(data?: IUpdateArticleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.coverPhoto = _data["coverPhoto"];
            this.thumbnail = _data["thumbnail"];
            this.title = _data["title"];
            this.content = _data["content"];
            this.type = _data["type"];
            this.shouldHideAuthorInfo = _data["shouldHideAuthorInfo"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(ArticleTagDto.fromJS(item));
            }
            if (Array.isArray(_data["helpfulResources"])) {
                this.helpfulResources = [] as any;
                for (let item of _data["helpfulResources"])
                    this.helpfulResources!.push(HelpfulResourceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateArticleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateArticleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["coverPhoto"] = this.coverPhoto;
        data["thumbnail"] = this.thumbnail;
        data["title"] = this.title;
        data["content"] = this.content;
        data["type"] = this.type;
        data["shouldHideAuthorInfo"] = this.shouldHideAuthorInfo;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.helpfulResources)) {
            data["helpfulResources"] = [];
            for (let item of this.helpfulResources)
                data["helpfulResources"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IUpdateArticleDto {
    id?: string;
    coverPhoto?: string | undefined;
    thumbnail?: string | undefined;
    title?: string | undefined;
    content?: string | undefined;
    type?: ArticleType;
    shouldHideAuthorInfo?: boolean;
    tags?: ArticleTagDto[] | undefined;
    helpfulResources?: HelpfulResourceDto[] | undefined;
}

export class PaginatedListOfGetArticleSummaryDto implements IPaginatedListOfGetArticleSummaryDto {
    items?: GetArticleSummaryDto[] | undefined;
    pageIndex?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfGetArticleSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetArticleSummaryDto.fromJS(item));
            }
            this.pageIndex = _data["pageIndex"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfGetArticleSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfGetArticleSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["pageIndex"] = this.pageIndex;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfGetArticleSummaryDto {
    items?: GetArticleSummaryDto[] | undefined;
    pageIndex?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class GetArticleSummaryDto implements IGetArticleSummaryDto {
    id?: string;
    thumbnail?: string | undefined;
    title?: string | undefined;
    content?: string | undefined;
    shouldHideAuthorInfo?: boolean;
    tags?: ArticleTagDto[] | undefined;
    scheduledPublishOn?: Date | undefined;
    reviewNotes?: string | undefined;
    status?: ArticleStatus;
    type?: ArticleType;
    showOnHomePage?: boolean;
    showAsBannerArticle?: boolean;
    createdOn?: Date;
    createdBy?: BaseUserDto | undefined;
    modifiedOn?: Date | undefined;
    modifiedBy?: BaseUserDto | undefined;

    constructor(data?: IGetArticleSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.thumbnail = _data["thumbnail"];
            this.title = _data["title"];
            this.content = _data["content"];
            this.shouldHideAuthorInfo = _data["shouldHideAuthorInfo"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(ArticleTagDto.fromJS(item));
            }
            this.scheduledPublishOn = _data["scheduledPublishOn"] ? new Date(_data["scheduledPublishOn"].toString()) : <any>undefined;
            this.reviewNotes = _data["reviewNotes"];
            this.status = _data["status"];
            this.type = _data["type"];
            this.showOnHomePage = _data["showOnHomePage"];
            this.showAsBannerArticle = _data["showAsBannerArticle"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"] ? BaseUserDto.fromJS(_data["createdBy"]) : <any>undefined;
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"] ? BaseUserDto.fromJS(_data["modifiedBy"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetArticleSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetArticleSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["thumbnail"] = this.thumbnail;
        data["title"] = this.title;
        data["content"] = this.content;
        data["shouldHideAuthorInfo"] = this.shouldHideAuthorInfo;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : <any>undefined);
        }
        data["scheduledPublishOn"] = this.scheduledPublishOn ? this.scheduledPublishOn.toISOString() : <any>undefined;
        data["reviewNotes"] = this.reviewNotes;
        data["status"] = this.status;
        data["type"] = this.type;
        data["showOnHomePage"] = this.showOnHomePage;
        data["showAsBannerArticle"] = this.showAsBannerArticle;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy ? this.modifiedBy.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetArticleSummaryDto {
    id?: string;
    thumbnail?: string | undefined;
    title?: string | undefined;
    content?: string | undefined;
    shouldHideAuthorInfo?: boolean;
    tags?: ArticleTagDto[] | undefined;
    scheduledPublishOn?: Date | undefined;
    reviewNotes?: string | undefined;
    status?: ArticleStatus;
    type?: ArticleType;
    showOnHomePage?: boolean;
    showAsBannerArticle?: boolean;
    createdOn?: Date;
    createdBy?: BaseUserDto | undefined;
    modifiedOn?: Date | undefined;
    modifiedBy?: BaseUserDto | undefined;
}

export class BaseUserDto implements IBaseUserDto {
    id?: string;
    displayName?: string | undefined;

    constructor(data?: IBaseUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): BaseUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new BaseUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IBaseUserDto {
    id?: string;
    displayName?: string | undefined;
}

export enum ListSortDirection {
    Ascending = 0,
    Descending = 1,
}

export class ArticlesHomeDto implements IArticlesHomeDto {
    latestFromSurface?: GetArticleSummaryDto[] | undefined;
    topStories?: GetArticleSummaryDto[] | undefined;
    surfacePrograms?: GetArticleSummaryDto[] | undefined;
    productArticles?: GetArticleSummaryDto[] | undefined;
    industryInsights?: GetArticleSummaryDto[] | undefined;

    constructor(data?: IArticlesHomeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["latestFromSurface"])) {
                this.latestFromSurface = [] as any;
                for (let item of _data["latestFromSurface"])
                    this.latestFromSurface!.push(GetArticleSummaryDto.fromJS(item));
            }
            if (Array.isArray(_data["topStories"])) {
                this.topStories = [] as any;
                for (let item of _data["topStories"])
                    this.topStories!.push(GetArticleSummaryDto.fromJS(item));
            }
            if (Array.isArray(_data["surfacePrograms"])) {
                this.surfacePrograms = [] as any;
                for (let item of _data["surfacePrograms"])
                    this.surfacePrograms!.push(GetArticleSummaryDto.fromJS(item));
            }
            if (Array.isArray(_data["productArticles"])) {
                this.productArticles = [] as any;
                for (let item of _data["productArticles"])
                    this.productArticles!.push(GetArticleSummaryDto.fromJS(item));
            }
            if (Array.isArray(_data["industryInsights"])) {
                this.industryInsights = [] as any;
                for (let item of _data["industryInsights"])
                    this.industryInsights!.push(GetArticleSummaryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ArticlesHomeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArticlesHomeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.latestFromSurface)) {
            data["latestFromSurface"] = [];
            for (let item of this.latestFromSurface)
                data["latestFromSurface"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.topStories)) {
            data["topStories"] = [];
            for (let item of this.topStories)
                data["topStories"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.surfacePrograms)) {
            data["surfacePrograms"] = [];
            for (let item of this.surfacePrograms)
                data["surfacePrograms"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.productArticles)) {
            data["productArticles"] = [];
            for (let item of this.productArticles)
                data["productArticles"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.industryInsights)) {
            data["industryInsights"] = [];
            for (let item of this.industryInsights)
                data["industryInsights"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IArticlesHomeDto {
    latestFromSurface?: GetArticleSummaryDto[] | undefined;
    topStories?: GetArticleSummaryDto[] | undefined;
    surfacePrograms?: GetArticleSummaryDto[] | undefined;
    productArticles?: GetArticleSummaryDto[] | undefined;
    industryInsights?: GetArticleSummaryDto[] | undefined;
}

export class UrlMetadataDto implements IUrlMetadataDto {
    url?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    imageSrc?: string | undefined;

    constructor(data?: IUrlMetadataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.imageSrc = _data["imageSrc"];
        }
    }

    static fromJS(data: any): UrlMetadataDto {
        data = typeof data === 'object' ? data : {};
        let result = new UrlMetadataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["title"] = this.title;
        data["description"] = this.description;
        data["imageSrc"] = this.imageSrc;
        return data;
    }
}

export interface IUrlMetadataDto {
    url?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    imageSrc?: string | undefined;
}

export class RedraftArticleDto implements IRedraftArticleDto {
    reviewNotes?: string | undefined;

    constructor(data?: IRedraftArticleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reviewNotes = _data["reviewNotes"];
        }
    }

    static fromJS(data: any): RedraftArticleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RedraftArticleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reviewNotes"] = this.reviewNotes;
        return data;
    }
}

export interface IRedraftArticleDto {
    reviewNotes?: string | undefined;
}

export class PublishArticleDto implements IPublishArticleDto {
    showOnHomePage?: boolean;
    showAsBannerArticle?: boolean;

    constructor(data?: IPublishArticleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.showOnHomePage = _data["showOnHomePage"];
            this.showAsBannerArticle = _data["showAsBannerArticle"];
        }
    }

    static fromJS(data: any): PublishArticleDto {
        data = typeof data === 'object' ? data : {};
        let result = new PublishArticleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["showOnHomePage"] = this.showOnHomePage;
        data["showAsBannerArticle"] = this.showAsBannerArticle;
        return data;
    }
}

export interface IPublishArticleDto {
    showOnHomePage?: boolean;
    showAsBannerArticle?: boolean;
}

export class ScheduleToPublishArticleDto implements IScheduleToPublishArticleDto {
    scheduledPublishOn?: Date;
    showOnHomePage?: boolean;
    showAsBannerArticle?: boolean;

    constructor(data?: IScheduleToPublishArticleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scheduledPublishOn = _data["scheduledPublishOn"] ? new Date(_data["scheduledPublishOn"].toString()) : <any>undefined;
            this.showOnHomePage = _data["showOnHomePage"];
            this.showAsBannerArticle = _data["showAsBannerArticle"];
        }
    }

    static fromJS(data: any): ScheduleToPublishArticleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleToPublishArticleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scheduledPublishOn"] = this.scheduledPublishOn ? this.scheduledPublishOn.toISOString() : <any>undefined;
        data["showOnHomePage"] = this.showOnHomePage;
        data["showAsBannerArticle"] = this.showAsBannerArticle;
        return data;
    }
}

export interface IScheduleToPublishArticleDto {
    scheduledPublishOn?: Date;
    showOnHomePage?: boolean;
    showAsBannerArticle?: boolean;
}

export class GetArticleTemplateDetailDto implements IGetArticleTemplateDetailDto {
    id?: string;
    displayName?: string | undefined;
    content?: string | undefined;
    coverPhoto?: string | undefined;
    thumbnail?: string | undefined;

    constructor(data?: IGetArticleTemplateDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.content = _data["content"];
            this.coverPhoto = _data["coverPhoto"];
            this.thumbnail = _data["thumbnail"];
        }
    }

    static fromJS(data: any): GetArticleTemplateDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetArticleTemplateDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["content"] = this.content;
        data["coverPhoto"] = this.coverPhoto;
        data["thumbnail"] = this.thumbnail;
        return data;
    }
}

export interface IGetArticleTemplateDetailDto {
    id?: string;
    displayName?: string | undefined;
    content?: string | undefined;
    coverPhoto?: string | undefined;
    thumbnail?: string | undefined;
}

export class CreateArticleTemplateDto implements ICreateArticleTemplateDto {
    displayName?: string | undefined;
    content?: string | undefined;
    coverPhoto?: string | undefined;
    thumbnail?: string | undefined;

    constructor(data?: ICreateArticleTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.content = _data["content"];
            this.coverPhoto = _data["coverPhoto"];
            this.thumbnail = _data["thumbnail"];
        }
    }

    static fromJS(data: any): CreateArticleTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateArticleTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["content"] = this.content;
        data["coverPhoto"] = this.coverPhoto;
        data["thumbnail"] = this.thumbnail;
        return data;
    }
}

export interface ICreateArticleTemplateDto {
    displayName?: string | undefined;
    content?: string | undefined;
    coverPhoto?: string | undefined;
    thumbnail?: string | undefined;
}

export class GetArticleTemplateSummaryDto implements IGetArticleTemplateSummaryDto {
    id?: string;
    displayName?: string | undefined;
    createdBy?: BaseUserDto | undefined;

    constructor(data?: IGetArticleTemplateSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.createdBy = _data["createdBy"] ? BaseUserDto.fromJS(_data["createdBy"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetArticleTemplateSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetArticleTemplateSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetArticleTemplateSummaryDto {
    id?: string;
    displayName?: string | undefined;
    createdBy?: BaseUserDto | undefined;
}

export class GetAuthorDto implements IGetAuthorDto {
    id?: string;
    displayName?: string | undefined;
    email?: string | undefined;
    userDomain?: RequestDomain | undefined;
    twitterUrl?: string | undefined;
    linkedInUrl?: string | undefined;
    aboutMe?: string | undefined;

    constructor(data?: IGetAuthorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.email = _data["email"];
            this.userDomain = _data["userDomain"];
            this.twitterUrl = _data["twitterUrl"];
            this.linkedInUrl = _data["linkedInUrl"];
            this.aboutMe = _data["aboutMe"];
        }
    }

    static fromJS(data: any): GetAuthorDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAuthorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["email"] = this.email;
        data["userDomain"] = this.userDomain;
        data["twitterUrl"] = this.twitterUrl;
        data["linkedInUrl"] = this.linkedInUrl;
        data["aboutMe"] = this.aboutMe;
        return data;
    }
}

export interface IGetAuthorDto {
    id?: string;
    displayName?: string | undefined;
    email?: string | undefined;
    userDomain?: RequestDomain | undefined;
    twitterUrl?: string | undefined;
    linkedInUrl?: string | undefined;
    aboutMe?: string | undefined;
}

export class UpdateAboutAuthorDto implements IUpdateAboutAuthorDto {
    id?: string;
    twitterUrl?: string | undefined;
    linkedInUrl?: string | undefined;
    aboutMe?: string | undefined;

    constructor(data?: IUpdateAboutAuthorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.twitterUrl = _data["twitterUrl"];
            this.linkedInUrl = _data["linkedInUrl"];
            this.aboutMe = _data["aboutMe"];
        }
    }

    static fromJS(data: any): UpdateAboutAuthorDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAboutAuthorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["twitterUrl"] = this.twitterUrl;
        data["linkedInUrl"] = this.linkedInUrl;
        data["aboutMe"] = this.aboutMe;
        return data;
    }
}

export interface IUpdateAboutAuthorDto {
    id?: string;
    twitterUrl?: string | undefined;
    linkedInUrl?: string | undefined;
    aboutMe?: string | undefined;
}

export class PaginatedListOfGetAuthorDto implements IPaginatedListOfGetAuthorDto {
    items?: GetAuthorDto[] | undefined;
    pageIndex?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfGetAuthorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAuthorDto.fromJS(item));
            }
            this.pageIndex = _data["pageIndex"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfGetAuthorDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfGetAuthorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["pageIndex"] = this.pageIndex;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfGetAuthorDto {
    items?: GetAuthorDto[] | undefined;
    pageIndex?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ArticleApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isArticleApiException = true;

    static isArticleApiException(obj: any): obj is ArticleApiException {
        return obj.isArticleApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ArticleApiException(message, status, response, headers, null);
}

// Adds Authorization header to requests made by the nswag generated clients

export class ApiError extends Error {
    status: number;
    statusText: string;
    detail: any;

    constructor(status: number, statusText: string, detail?: any) {
        super(`${status} ${statusText}`);
        this.name = 'ApiError';
        this.status = status;
        this.statusText = statusText;
        this.detail = detail;
    }

    static isApiError(obj: any): obj is ApiError {
        return obj instanceof ApiError;
    }
}